/* src/app/reporting/pages/report-load-counter/report-load-counter.component.scss */
/*# sourceMappingURL=report-load-counter.component.css.map */
